import { render, staticRenderFns } from "./IptNumberBtn.vue?vue&type=template&id=0e2b0efe&scoped=true&"
import script from "./IptNumberBtn.vue?vue&type=script&lang=js&"
export * from "./IptNumberBtn.vue?vue&type=script&lang=js&"
import style0 from "./IptNumberBtn.vue?vue&type=style&index=0&id=0e2b0efe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2b0efe",
  null
  
)

export default component.exports